import { render, staticRenderFns } from "./DNSManager.vue?vue&type=template&id=00f2de78&"
import script from "./DNSManager.vue?vue&type=script&lang=js&"
export * from "./DNSManager.vue?vue&type=script&lang=js&"
import style0 from "./DNSManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports